import * as st from './heroshot.module.scss'
import * as React from 'react'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import { CirclePlayButtonPlaceholder } from '../circlePlayButton/circlePlayButtonPlaceholder'
import { Packshot } from './packshot'
import { ResponsiveImage } from '../images/responsiveImage'
import { SrcSize } from '../../utils/imageUtils'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { isTVSelector } from '../../selectors/shared'
import { sessionIdSelector, isRetailSelector, marketplaceIdSelector } from '../../selectors/requestContext'
import { simpleSelectors } from '../../selectors/basicState'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'
import { imagesSelector } from '../../selectors/detailFragment'
import { playbackFirstChildSelector } from '../../selectors/actionFragment'
import { isJPMarketplace } from '../../utils/marketplace'
import { nodeDeeplinkingSelector } from '../../selectors/player'
import { isTreatment } from '../../utils/utils'
import * as cn from 'classnames'
import { HEROSHOT_DESKTOP_WIDTH, HEROSHOT_MOBILE_WIDTH, HEROSHOT_TABLET_WIDTH } from './heroConstants'

type StateProps = ReturnType<typeof mapStateToProps>
export type Props = StateProps

export const ConnectedHeroshot = ({ images, marketplaceId, playbackData, sessionId, pageTitleId, isRetail, isTV, isDeeplinkableActionReady, useNodeDeeplinking, atfTreatment }: Props) => {
  if (!images) {
    return null
  }

  const heroshot = !isJPMarketplace(marketplaceId) && images.heroshot // Force no heroshot in jp
  const packshot = images.packshot


  if (!heroshot) {
    return (
      <Packshot
        packshot={packshot}
        playbackData={playbackData}
        sessionId={sessionId}
        pageTitleId={pageTitleId}
        isRetail={isRetail}
        isTV={isTV}
        useNodeDeeplinking={useNodeDeeplinking}
        atfTreatment={atfTreatment}
      />
    )
  }

  const heroshotImgProps = {
    alt: '', // Decorative image so no alt
    src: heroshot,
    baseValue: HEROSHOT_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': HEROSHOT_MOBILE_WIDTH },
      { 'max-tablet': HEROSHOT_TABLET_WIDTH },
      {'min-tablet': HEROSHOT_DESKTOP_WIDTH}
    ] as SrcSize[]
  }

  const shouldShowCirclePlay = !global.__NATIVEAPP__ && isRetail

  return (
    <React.Fragment>
      <div className={cn(st.avHeroBackground, st.heroshotOpacity, 'av-hero-background', {[st.avHeroBackgroundRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}
           data-automation-id="hero-background">
        <div className={cn(st.imageFadeWrapper, {[st.imageFadeWrapperRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
          <ResponsiveImage className={`${st.heroshot}`} {...heroshotImgProps} />
          {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <div className={st.avHeroBackgroundFadeLeft}/>}
          <div className={st.avHeroBackgroundFadeBottom}/>
        </div>
        {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && shouldShowCirclePlay && (
          <div className="playback-large-circle-wrapper">
            <div id="dv-play-box-circle">
              {isDeeplinkableActionReady && playbackData && (
                <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} useNodeDeeplinking={useNodeDeeplinking}/>
              )}
            </div>
          </div>
        )}
      </div>
      {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && shouldShowCirclePlay && <CirclePlayButtonPlaceholder />}
      {isTreatment(atfTreatment, 'T1', 'T2', 'T3') &&
        <div className={st.heroSpace}>
          {isTreatment(atfTreatment, 'T3') && shouldShowCirclePlay && isDeeplinkableActionReady && playbackData &&
            <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} useNodeDeeplinking={useNodeDeeplinking} atfTreatment={atfTreatment}/>}
        </div>
      }
    </React.Fragment>
  )
}


const mapStateToProps = (state: IDetailPageState) => ({
  sessionId: sessionIdSelector(state),
  pageTitleId: simpleSelectors.pageTitleId(state),
  isRetail: isRetailSelector(state),
  isTV: isTVSelector(state),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
  marketplaceId: marketplaceIdSelector(state),
  images: imagesSelector(state),
  playbackData: playbackFirstChildSelector(state),
  useNodeDeeplinking: nodeDeeplinkingSelector(state),
  atfTreatment: simpleSelectors.atfTreatment(state)
})

export const Heroshot = connect(mapStateToProps)(ConnectedHeroshot)